module.exports = __webpack_public_path__ + "static/media/helsinki-15.2f1d6009.jpg";